<template>
  <div class="row">

    <div class="col-12">
      <b-card header="Add new company" header-tag="h4" body-class="mb-3 pb-2">

        <ValidationObserver ref="newCompanyLeadForm" slim v-slot="{ invalid }">
          <form role="form" @submit.prevent="onSubmit">
            <div class="row">
              <!-- Company Name - Input -->
              <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Company Name" tag="div"
                class="col-xl-8 form-group">
                <label class="form-label" for="company_name">Company Name</label>
                <input type="text" v-model="company.company_name" id="company_name" name="company_name"
                  class="form-input" :class="classes" autocomplete="off" autofocus>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>

              <!-- Company LTD Number - Input -->
              <ValidationProvider rules="required" v-slot="{ errors, classes }" name="LTD Registration Number" tag="div"
                class="col-xl-4 form-group">
                <label class="form-label" for="ltd_reg_number">LTD Registration Number</label>
                <input type="text" v-model="company.ltd_reg_number" id="ltd_reg_number" name="ltd_reg_number"
                  class="form-input" :class="classes">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="card_inset">
              <div class="row">
                <div class="col-12">
                  <h5 class="font-weight-bold">Registered Address</h5>
                  <hr class="mt-2 mb-3">
                </div>

                <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Building" tag="div"
                  class="col-xl-4 form-group">
                  <label class="form-label" :for="'building'">Building</label>
                  <input type="text" v-model="company_address.building" id="building" name="building"
                    class="form-input">
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Street" tag="div"
                  class="col-xl-4 form-group">
                  <label class="form-label" :for="'street'">Street</label>
                  <input type="text" v-model="company_address.street" id="street" name="street" class="form-input">
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider rules="" v-slot="{ errors, classes }" name="Locality" tag="div"
                  class="col-xl-4 form-group">
                  <label class="form-label" :for="'locality'">Locality</label>
                  <input type="text" v-model="company_address.locality" id="locality" name="locality"
                    class="form-input">
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider rules="required" v-slot="{ errors, classes }" name="City" tag="div"
                  class="col-xl-4 form-group">
                  <label class="form-label" :for="'city_town'">City</label>
                  <input type="text" v-model="company_address.city_town" id="city_town" name="city_town"
                    class="form-input">
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider rules="" v-slot="{ errors, classes }" name="County" tag="div"
                  class="col-xl-4 form-group">
                  <label class="form-label" :for="'county'">County</label>
                  <input type="text" v-model="company_address.county" id="county" name="county" class="form-input">
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Postcode" tag="div"
                  class="col-xl-4 form-group">
                  <label class="form-label" :for="'postcode'">Postcode</label>
                  <input type="text" v-model="company_address.postcode" id="postcode" name="postcode"
                    class="form-input">
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>

              </div>
            </div>
            <div class="card_inset mt-3">
              <div class="row">
                <div class="col-12">
                  <h5 class="font-weight-bold">Contact</h5>
                  <hr class="mt-2 mb-3">
                </div>
                <div class="col-xl-4 col-md-6">

                  <div class="row mt-3">
                    <ValidationProvider rules="required|alpha" v-slot="{ errors, classes }" name="First Name" tag="div"
                      class="col-12 form-group">
                      <label class="form-label" :for="'first_name'">First Name</label>
                      <input type="text" v-model="contact.first_name" :id="'first_name'" :name="'first_name'"
                        class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <ValidationProvider rules="required|alpha" v-slot="{ errors, classes }" name="Surname" tag="div"
                      class="col-12 form-group">
                      <label class="form-label" :for="'surname'">Surname</label>
                      <input type="text" v-model="contact.surname" :id="'surname'" :name="'surname'"
                        class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <ValidationProvider rules="required|email" v-slot="{ errors, classes }" name="Email Address" tag="div"
                      class="col-12 form-group">
                      <label class="form-label" :for="'email'">Email</label>
                      <input type="email" v-model="contact.email" :id="'email'" :name="'email'" class="form-input"
                        :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <ValidationProvider rules="required|max:25" v-slot="{ errors, classes }" name="Mobile"
                      tag="div" class="col-12 form-group">
                      <label class="form-label" :for="'mobile'">Mobile Number</label>
                      <input type="text" v-model="contact.mobile" :id="'mobile'" :name="'mobile'" class="form-input"
                        :class="classes" maxlength="15">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <ValidationProvider rules="decimal|max:25" v-slot="{ errors, classes }" name="Landline"
                      tag="div" class="col-12 form-group">
                      <label class="form-label" :for="'phone'">Landline Number</label>
                      <input type="text" v-model="contact.phone" :id="'phone'" :name="'phone'" class="form-input"
                        :class="classes" maxlength="15">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <hr class="mt-2 mb-0">

                </div>
              </div>
            </div>

            <div class="row mt-3 mb-2">
              <div class="col-xl-6">
                <button class="btn orcaBtn grey_bg w-100 mb-3" @click.prevent="save_lead_add_another(invalid)"
                  :disabled="save_add_another">
                  <span v-if="save_add_another" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving lead
                    ...</span>
                  <span v-else>Save lead - Add another</span>
                </button>
              </div>
              <div class="col-xl-6">
                <button class="btn orcaBtn grey_bg w-100 mb-3" @click.prevent="new_company_lead_submit(invalid)"
                  :disabled="save_go_profile">
                  <span v-if="save_go_profile" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving lead
                    ...</span>
                  <span v-else>Save lead - go to profile</span>
                </button>
              </div>
            </div>

          </form>
        </ValidationObserver>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'create_raw',
  components: {},
  data() {
    return {
      save_add_another: false,
      save_go_profile: false,
      // current signed in crm user details
      user: this.$store.state.auth.me,
      searching_companies_house: false,
      company_search_results: {},
      company: {
        primary_consultant_id: this.$store.state.auth.me.id,
        company_name: '',
        company_type: 'Prospect',
        company_type_update: this.$moment.utc().format('YYYY-MM-DD'),
        ltd_reg_number: null,
      },
      company_details_visible: false,
      company_address: {
        company_id: null,
        address_type: 41, // Company Address Type => 'Registered Office'
        building: null,
        street: null,
        locality: null,
        city_town: null,
        county: null,
        postcode: null,
        full: null
      },
      contact: {
        company_id: null,
        first_name: null,
        surname: null,
        email: null,
        mobile: null,
        phone: null
      }
    }
  },
  methods: {
    // Reset the form back to initial state
    reset_form() {
      this.searching_companies_house = false;
      this.company_search_results = {};
      this.company = {
        primary_consultant_id: this.$store.state.auth.me.id,
        company_name: '',
        company_type: 'Prospect',
        company_type_update: this.$moment.utc().format('YYYY-MM-DD'),
        ltd_reg_number: null,
      };
      this.company_address = {
        company_id: null,
        address_type_id: 41, // Company Address Type => 'Registered Office'
        building: null,
        street: null,
        locality: null,
        city_town: null,
        county: null,
        postcode: null,
        full: null
      };
      this.contact = {
        company_id: null,
        first_name: null,
        surname: null,
        email: null,
        mobile: null,
        phone: null
      },
        this.company_details_visible = false;
    },
    // Function to save the contacts for a company
    save_contacts(company_id) {
      let promises = []
      promises.push(new Promise((complete) => {

        // set required variables for saving contact
        this.contact.company_id = company_id;
        this.contact.log_by_type = 'App\\Models\\Users\\User';
        this.contact.log_by_id = this.$store.state.auth.me.id;

        // save contact
        axios.post(this.crmApiPath + 'contact', this.contact).then(contact_id => {

          let contact_promises = [];
          contact_promises.push(new Promise(resolve => {
            let mobile = {
              'company_id': company_id,
              'contact_id': contact_id.data,
              'belongs_to_id': contact_id.data,
              'belongs_to_type': 'App\\Models\\Companies\\Contacts\\Contact',
              'contact_info_model_type': 'App\\Models\\Contact_Info\\Phone',
              'log_by_id': this.$store.state.auth.me.id,
              'record_type': 'contact',
              'phone_type_id': 57, // work mobile
              'phone_number': this.contact.mobile
            }
            axios.post(this.crmApiPath + 'contact_info/phone', mobile).then(() => resolve());
          }));
          
          if (this.contact.phone) {
            contact_promises.push(new Promise(resolve => {
              let phone = {
                'company_id': company_id,
                'contact_id': contact_id.data,
                'belongs_to_id': contact_id.data,
                'belongs_to_type': 'App\\Models\\Companies\\Contacts\\Contact',
                'contact_info_model_type': 'App\\Models\\Contact_Info\\Phone',
                'log_by_id': this.$store.state.auth.me.id,
                'record_type': 'contact',
                'phone_type_id': 56, // work landline
                'phone_number': this.contact.phone
              }
              axios.post(this.crmApiPath + 'contact_info/phone', phone).then(() => resolve());
            }));
          }
          else {
            contact_promises.push(new Promise(resolve => resolve()));
          }

          contact_promises.push(new Promise(resolve => {
            let email = {
              'company_id': company_id,
              'contact_id': contact_id.data,
              'belongs_to_id': contact_id.data,
              'belongs_to_type': 'App\\Models\\Companies\\Contacts\\Contact',
              'contact_info_model_type': 'App\\Models\\Contact_Info\\Email',
              'log_by_id': this.$store.state.auth.me.id,
              'record_type': 'contact',
              'email_type_id': 63, // work email
              'email_address': this.contact.email
            }
            axios.post(this.crmApiPath + 'contact_info/email', email).then(() => resolve());
          }));

          Promise.all(contact_promises).then(() => complete());
        });
      }));

      return Promise.all(promises)
    },
    // SUBMIT FUNCTIONS
    save_company_company(type) {
      // Set log values for creating the worker (current crm user)
      this.company.log_by_type = 'App\\Models\\Users\\User';
      this.company.log_by_id = this.user.id;
      this.company_address.full = this.calc_nice_address(
          this.company_address.building,
          this.company_address.street,
          this.company_address.locality,
          this.company_address.city_town,
          this.company_address.county,
          this.company_address.postcode
      );

      return axios.post(this.crmApiPath + 'company', this.company).then(company_id => {
        let company_profile = {
          'log_by_type': 'App\\Models\\Users\\User',
          'log_by_id': this.$store.state.auth.me.id,
          'company_id': company_id.data,
          'ltd_reg_number': this.company.ltd_reg_number
        };
        axios.post(this.crmApiPath + 'company/profile', company_profile).then(() => {
          this.save_contacts(company_id.data).then(() => {
              this.company_address.company_id = company_id.data;
              this.company_address.belongs_to_id = company_id.data;
              this.company_address.belongs_to_type = 'App\\Models\\Companies\\Company';
              this.company_address.contact_info_model_type = 'App\\Models\\Contact_Info\\Address';
              this.company_address.address_type_id = 41;
              this.company_address.log_by_id = this.$store.state.auth.me.id;
              this.company_address.record_type = 'company';
              axios.post(this.crmApiPath + 'contact_info/address', this.company_address).then(() => {
                this.$snotify.success(this.company.company_name + ' added to CRM ');

                if (type === 'add_another') {
                  this.$nextTick(() => {
                    this.company.company_name = null;
                    this.reset_form()
                    this.save_add_another = false;
                  })
                }
                else if (type === 'go_to_profile') {
                  this.$store.commit('CURRENT_RECORD_COMPANY_ID', company_id.data);
                  this.$store.commit('SET_COMPANY_TAB_INDEX', 0);
                  this.$nextTick(() => {
                    this.save_go_profile = false;
                    this.$tabs.close({
                      path: this.$router.currentRoute.fullPath,
                      to: '/company/record'
                    });
                    this.$tabs.refresh('/company/record', true);
                  });
                }
                
              });
          })
        })
      });
    },
    // button functions
    save_lead_add_another(valid) {
      this.$refs.newCompanyLeadForm.validate().then((isValid) => {
        if (isValid) {
          this.save_add_another = true;
          this.save_company_company('add_another');
        } else {
          alert('Form is not valid. Please correct the errors and try again.');
        }
      });
    },

    new_company_lead_submit(valid) {
      this.$refs.newCompanyLeadForm.validate().then((isValid) => {
        if (isValid) {
          this.save_go_profile = true;
          this.save_company_company('go_to_profile')
        } else {
          alert('Form is not valid. Please correct the errors and try again.');
        }
      });
    }
  },
  beforeDestroy() {
    this.save_add_another = false;
    this.save_go_profile = false;
    this.searching_companies_house = false;
    this.company_search_results = {};
    this.company_details_visible = false;
    this.awaitingTradingNameSearch = false;
    this.showSubmitBtn = false;
    this.contact = {
      full_name: null,
      email: null,
      mobile: null,
      phone: null
    };
  }
}
</script>
<style scoped lang="scss">
.companies_house_company_search {
  position: absolute;
  background: $card_background;
  border: 1px solid $card_background;
  border-bottom-left-radius: $border_radius;
  border-bottom-right-radius: $border_radius;
  box-shadow: 0 1px 5px 0 rgba($bc_2, 0.5);
  z-index: 99;
  max-height: 230px;
  overflow-y: scroll;
  width: 100%;

  ul {
    list-style-type: none;
    padding-left: 0;
    margin-bottom: 0;

    li {
      button {
        padding: 7.5px 10px;
        border: none;
        width: 100%;
        text-align: left;
        background: none;

        &.disabled {
          background: lighten($bc_5, 0%);
        }

        .c_status,
        .c_title,
        .c_number,
        .c_address_snippet {
          display: block;
          width: 100%;
          line-height: 1;
        }

        .c_status,
        .c_number {
          margin-bottom: 2.5px;
        }

        .c_status {
          text-transform: capitalize;
          color: $red;
          font-size: 0.65rem;

          &.active {
            color: #008000;
          }
        }

        .c_title {
          font-weight: bold;
          margin-bottom: 1.5px;
          color: $bc_2;
          font-size: 0.85rem;
        }

        .c_number {
          font-size: 0.7rem;
        }

        .c_address_snippet {
          font-size: 0.6rem;
          color: $bc_3;
        }

        &.clickable {

          &:hover,
          &:focus,
          &:active,
          &:active:focus,
          &.active:focus,
          &.focus,
          &:active.focus,
          &.active.focus {
            background: lighten($bc_5, 12.5%);
            outline: none;
          }
        }

      }

      border-bottom: 1px solid $bc_2;

      &:last-of-type {
        border-bottom: none;

        button {
          border-bottom-left-radius: $border_radius;
          border-bottom-right-radius: $border_radius;
        }
      }
    }

  }
}

.card_inset {
  padding: 10px 12px 5px 12px;
  background: darken($card_background, 2.5%);

  .inset_card_inset {
    padding: 10px 12px 10px 12px;
    background: $card_background;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss"></style>
